import { useState } from 'react';
import { Table, TablePaginationConfig, Tag } from 'antd';
import dayjs from 'dayjs';

import { useMeetingByStatus } from '../../hooks/useMeetings';
import UserManagementSkeleton from '../Skeleton/UserManagement';

import { RequestedMeetingType } from '../../types/meeting';
import { useAppStore } from '../../store/appStore';

const CompletedMeeting = () => {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  const profile = useAppStore((state) => state.profile);
  const userId = profile.user.id;

  // Fetch requested meetings with server-side pagination
  const { data: meetings, isLoading, error } = useMeetingByStatus('COMPLETED', page, limit, userId);
  const data = meetings?.data || [];

  const columns = [
    { title: 'Title', dataIndex: 'title', key: 'title' },
    { title: 'Organization', dataIndex: 'organization', key: 'organization' },
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
      render: (date: string) => dayjs(date).format('DD-MM-YYYY'),
      sorter: (a: RequestedMeetingType, b: RequestedMeetingType) =>
        dayjs(a.date).unix() - dayjs(b.date).unix(),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status: string) => <Tag color="magenta">{status}</Tag>,
    },
  ];

  const handleTableChange = (pagination: TablePaginationConfig) => {
    if (pagination.current) setPage(pagination.current);
    if (pagination.pageSize) setLimit(pagination.pageSize);
  };

  if (isLoading) return <UserManagementSkeleton />;
  if (error) return <div>Error: {error.message}</div>;

  return (
    <div>
      <Table
        dataSource={data}
        columns={columns}
        rowKey="id"
        pagination={{
          current: meetings?.pagination.page || page,
          pageSize: meetings?.pagination.limit || limit,
          total: meetings?.pagination.total || 0,
          showSizeChanger: true,
          showTotal: (total) => `Total ${total} meetings`,
        }}
        onChange={handleTableChange}
        className="overflow-x-auto"
      />
    </div>
  );
};

export default CompletedMeeting;
